import { axios } from '@/utils/request'
// 获取所有标签
export function getUserMaterialTag(params) {
  return axios({
    url: '/distribution/userMaterialTag/?is_all=1',
    method: 'GET',
    params
  })
}
// 添加标签
export function setUserMaterialTag(data) {
  return axios({
    url: '/distribution/userMaterialTag',
    method: 'POST',
    data
  })
}
// 修改标签
export function putUserMaterialTag(data, id) {
  return axios({
    url: '/distribution/userMaterialTag/' + id,
    method: 'PUT',
    data
  })
}
// 添加分类
export function addUserMaterialCategory(data) {
  return axios({
    url: '/distribution/userMaterialCategory',
    method: 'POST',
    data
  })
}
// 修改分类
export function editUserMaterialCategory(data) {
  const { parent_id } = data
  delete data.parent_id
  return axios({
    url: '/distribution/userMaterialCategory/' + parent_id,
    method: 'PUT',
    data
  })
}
// 获取用户素材
export function getUsermaterial(params) {
  return axios({
    url: '/distribution/material',
    method: 'GET',
    params
  })
}

// 删除素材
export function delUserMaterial(data) {
  return axios({
    url: '/distribution/material/deletes',
    method: 'POST',
    data
  })
}
// 修改素材
export function editUserMaterial(data) {
  return axios({
    url: '/distribution/material/' + data.id,
    method: 'PUT',
    data
  })
}
// 批量更改名字
export function editGruopNames(data) {
  return axios({
    url: '/distribution/material/names',
    method: 'POST',
    data
  })
}
// 批量更改标签
export function editGruopTags(data) {
  return axios({
    url: '/distribution/material/tags',
    method: 'POST',
    data
  })
}
// 批量更改分类
export function editGruopCategorys(data) {
  return axios({
    url: '/distribution/material/categorys',
    method: 'POST',
    data
  })
}
// 删除分类
export function deleteUserMaterialCategory(id) {
  return axios({
    url: '/distribution/userMaterialCategory/' + id,
    method: 'delete'
  })
}

// 共享素材
export function userMaterialShare(data) {
  return axios({
    url: '/distribution/material/share',
    method: 'POST',
    data
  })
}
// 更新分类排序
export function updateSort(data) {
  return axios({
    url: '/distribution/userMaterialCategory/updateSort',
    method: 'POST',
    data
  })
}
// 更新分类排序
export function exportMaterial(data) {
  return axios({
    url: '/distribution/material/exportMaterial',
    method: 'POST',
    data
  })
}
// 获取上传图片协议是否已勾选  1勾选  2 未勾选
export function getUploadMaterial(params) {
  return axios({
    url: '/distribution/userConfig/uploadMaterial',
    method: 'GET',
    params
  })
}
export function ptuUploadMaterial(data) {
  return axios({
    url: '/distribution/userConfig/uploadMaterial',
    method: 'PUT',
    data
  })
}
// 搜索相似素材
export function searchImage(data) {
  return axios({
    url: '/distribution/material/searchImage',
    method: 'POST',
    data
  })
}
// 使用url保存素材
export function urlMaterial(data) {
  return axios({
    url: '/distribution/material/urlMaterial',
    method: 'POST',
    data
  })
}
// 删除用户素材标签
export function deleteUserMaterialTag(id) {
  return axios({
    url: '/distribution/userMaterialTag/' + id,
    method: 'DELETE'
  })
}
// 共享分类
export function shareMaterial(data) {
  return axios({
    url: '/distribution/material/share',
    method: 'POST',
    data
  })
}
